import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_vm.showDialogCreate ? _c('core-deviceTemplate-add-wizard', {
    attrs: {
      "isOpen": _vm.showDialogCreate
    },
    on: {
      "close": function ($event) {
        _vm.showDialogCreate = false;
      },
      "created": _vm.finishedCreating
    }
  }) : _vm._e(), _vm.showDialogCopy && _vm.templateToCopy ? _c('core-deviceTemplate-copy-wizard', {
    attrs: {
      "isOpen": _vm.showDialogCopy,
      "sourceTemplate": _vm.templateToCopy
    },
    on: {
      "close": _vm.closeCopyDialog,
      "created": _vm.finishedCopying
    }
  }) : _vm._e(), _c('core-list-view-page', {
    ref: "listViewPage",
    attrs: {
      "fetch-items": _vm.fetchItems,
      "fetchErrorMessage": 'DigitalTwin.VirtualDevice.deviceTemplates.snacks.fetchError',
      "external-fetch-params": {
        accountFilterIsReady: _vm.accountFilterIsReady,
        selectedAccounts: _vm.selectedAccounts,
        cacheBuster: _vm.cacheBuster
      },
      "table-headers": _vm.tableHeaders,
      "headline": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.deviceTemplatesTitle'),
      "subtitle": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.deviceTemplatesSubTitle'),
      "row-href": item => _vm.getSingleTemplateUrl(item.id),
      "empty-state-icon": "fal fa-sensor-on",
      "empty-state-title": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.emptyState.title'),
      "empty-state-description": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.emptyState.description'),
      "listType": "deviceTemplates"
    },
    on: {
      "button:create": function ($event) {
        _vm.showDialogCreate = true;
      },
      "click:empty-state": function ($event) {
        _vm.showDialogCreate = true;
      }
    },
    scopedSlots: _vm._u([{
      key: "buttons-after",
      fn: function () {
        return [_c('core-account-filter', {
          attrs: {
            "multiple": ""
          },
          on: {
            "change": accounts => {
              _vm.selectedAccounts = accounts;
            },
            "ready": function ($event) {
              _vm.accountFilterIsReady = true;
            }
          }
        }), _c('core-prompt', {
          attrs: {
            "title": _vm.deletePromptTitle,
            "open": _vm.itemIdToBeDeleted !== null,
            "buttons": [{
              text: _vm.$i18n_t('DeviceDriver.list.deleteItem.prompt.cancelButton.label'),
              emit: 'cancel'
            }, {
              text: _vm.$i18n_t('DeviceDriver.list.deleteItem.prompt.deleteButton.label'),
              color: 'red',
              emit: 'delete',
              disabled: _vm.totalCountOfLinkedDevices > 0
            }]
          },
          on: {
            "cancel": function ($event) {
              _vm.itemIdToBeDeleted = null;
            },
            "delete": _vm.onDeleteItemConfirm
          }
        }, [_vm._v("\n        " + _vm._s(_vm.deletePromptDescription) + "\n        "), _vm.totalCountOfLinkedDevices > 0 ? [_c('div', {
          ref: "scrollContainer",
          staticStyle: {
            "height": "400px",
            "overflow-y": "auto"
          },
          on: {
            "scroll": _vm.handleScroll
          }
        }, [[_c(VTreeview, {
          staticClass: "mt-2 infoTree",
          attrs: {
            "items": _vm.linkedDevices,
            "item-key": "id"
          },
          scopedSlots: _vm._u([{
            key: "prepend",
            fn: function ({}) {
              return [_c(VIcon, {
                staticStyle: {
                  "width": "25px"
                },
                attrs: {
                  "size": "16"
                }
              }, [_vm._v("fal fa-sensor-on")])];
            }
          }, {
            key: "label",
            fn: function ({
              item
            }) {
              return [[_c('a', {
                attrs: {
                  "href": `/#/virtual-devices/${item.id}`,
                  "target": "_blank"
                }
              }, [_vm._v(_vm._s(_vm.get(item, 'title')))])], _vm._v("\n                   \n                  "), item.id ? _c('span', {
                staticStyle: {
                  "font-size": "10px"
                }
              }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.id) + ")")]) : _vm._e()];
            }
          }], null, false, 763714967)
        })]], 2)] : _vm._e()], 2)];
      },
      proxy: true
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };